/**
 * GENERATED by acetates/make_chips.py — do not edit by hand; re-run it when the acetate library
 * changes. Layout of ./assets/acetate-chips.jpg: one sample chip per acetate, library order,
 * 6 per row. A cell is 108 x 162 px: the 102 x 156 px chip face (3x the 34 x 52 CSS px
 * card of .mt-acetate-chip) inside a 3 px gutter of repeated edge pixels.
 */
export const ACETATE_CHIP_SPRITE = {
  columns: 6,
  rows: 6,
  cellPx: [108, 162],
  facePx: [102, 156],
  gutterPx: 3,
  scale: 3,
} as const;

/** Sprite cell order (index = row * columns + column): one sprite row per line. */
export const ACETATE_CHIP_IDS: readonly string[] = [
  'black', 'tortoise', 'honey-tortoise', 'blonde-tortoise', 'caramel', 'auburn-tortoise',
  'golden-tortoise', 'dark-tortoise', 'jaguar', 'green-tortoise', 'blue-tortoise', 'ivory-tortoise',
  'smoke', 'sand', 'taupe', 'cinnamon', 'rust', 'red',
  'burgundy', 'aubergine', 'cobalt', 'petrol', 'olive', 'denim',
  'copper-horn', 'cream-horn', 'glacier-horn', 'crackle', 'zebra', 'honeycomb',
  'green-marble', 'wine-marble', 'lilac', 'pearl-mint', 'oat',
];
